export const SET_VENUE_ID = 'SET_VENUE'
export const SET_TABLE_NUM = 'SET_TABLE'
export const SET_VENUE_OPEN = 'SET_VENUE_OPEN'
export const SET_SCAN_DATE = 'SET_SCAN_DATE'
export const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY'
